import { EnvironmentOutlined, MailOutlined } from '@ant-design/icons';
import { Col, Layout, Row } from 'antd';
import dayjs from 'dayjs';
import { SocialIcon } from 'react-social-icons';
import logo from '../../assets/images/ta-logo-grey.png';
import './ta-footer.css';
import { useTheme } from 'styled-components';
const { Footer } = Layout;

export function TAFooter(props) {
	const theme = useTheme();

	return (
		<Footer className="ta-footer">
			<Row className="py-4">
				<Col xs={{ span: 24 }} className="logo-container text-center mb-3 mb-lg-0" lg={{ span: 8 }}>
					<div>
						<img src={theme.HEADER_LOGO} style={{ width: '180px', padding: '.5rem' }} />
					</div>
					<div className="copywrite">
						<span>copyright {dayjs().format('YYYY')} @Talents Arena</span>
					</div>
				</Col>
				<Col xs={{ span: 24 }} className="social-links mb-3 mb-lg-0" lg={{ span: 8 }}>
					<SocialIcon
						url="https://www.facebook.com/thetalentsarena/"
						fgColor="#000000"
						bgColor="#ffffff"
						target="blank"
					/>
					<SocialIcon
						url="https://www.linkedin.com/company/talents-arena/"
						fgColor="#000000"
						bgColor="#ffffff"
						target="blank"
					/>
				</Col>
				<Col xs={{ span: 24 }} className="info-container mb-3 mb-lg-0" lg={{ span: 8 }}>
					<div className="mb-3">
						<a href="mailto:info@talentsarena.net" target="blank">
							<MailOutlined size={18} style={{ marginRight: '5px' }} />
							<span style={{ textAlign: 'center' }}>info@talentsarena.net</span>
						</a>
					</div>
					<div>
						<a
							href="https://www.google.com.eg/maps/place/Smart+Village/@30.0774707,31.0167231,15z/data=!4m2!3m1!1s0x0:0x9fbd976cf0e573b1?sa=X&ved=2ahUKEwiG4ZXS6pXmAhVE_qQKHWuqAb4Q_BIwCnoECA4QCA"
							target="blank"
						>
							<EnvironmentOutlined size={18} style={{ marginRight: '5px' }} />
							<span style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
								Smart Village, Cairo-Alex Desert Road, Egypt.
							</span>
						</a>
					</div>
				</Col>
			</Row>
		</Footer>
	);
}
